export const LockOutlineIcon = () => (
  <svg
    width="17"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_3366_3217)">
      <path d="M8.49984 11.3332C9.23317 11.3332 9.83317 10.7332 9.83317 9.99984C9.83317 9.2665 9.23317 8.6665 8.49984 8.6665C7.7665 8.6665 7.1665 9.2665 7.1665 9.99984C7.1665 10.7332 7.7665 11.3332 8.49984 11.3332ZM12.4998 5.33317H11.8332V3.99984C11.8332 2.15984 10.3398 0.666504 8.49984 0.666504C6.65984 0.666504 5.1665 2.15984 5.1665 3.99984V5.33317H4.49984C3.7665 5.33317 3.1665 5.93317 3.1665 6.6665V13.3332C3.1665 14.0665 3.7665 14.6665 4.49984 14.6665H12.4998C13.2332 14.6665 13.8332 14.0665 13.8332 13.3332V6.6665C13.8332 5.93317 13.2332 5.33317 12.4998 5.33317ZM6.43317 3.99984C6.43317 2.85984 7.35984 1.93317 8.49984 1.93317C9.63984 1.93317 10.5665 2.85984 10.5665 3.99984V5.33317H6.43317V3.99984ZM12.4998 13.3332H4.49984V6.6665H12.4998V13.3332Z" />
    </g>
    <defs>
      <clipPath id="clip0_3366_3217">
        <rect width="16" height="16" fill="white" transform="translate(0.5)" />
      </clipPath>
    </defs>
  </svg>
);
